// src/components/content/RiskRegister.js
import { useEffect, useRef, useState } from 'react';
import Header from '../header';
import {
  TextField,
  Select,
  MenuItem,
  Box,
  Button,
  Card,
  CardContent, TableContainer
} from '@mui/material';
import Iconify from 'src/components/iconify';
import {
  getComparator, useTable
} from 'src/components/table';
import { applyFilter } from 'src/layouts/_common/searchbar/utils';
import { getRequest, postRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import { LoadingScreen } from 'src/components/loading-screen';
import { LoadingButton } from '@mui/lab';
import BalanceSheetTable from './balance-sheet-table';
import { DatePicker } from '@mui/x-date-pickers';
import { enqueueSnackbar } from 'notistack';
import { CSVLink } from 'react-csv';
const BalanceSheet = ({ type, onSave, page, rowId }) => {
  const [ loading, setLoading ] = useState(false);
  const [ projectList, setprojectList ] = useState([]);
  const [ selectedProject, setSelectedProject ] = useState('All');
  const [ selectedTime, setSelectedTime ] = useState("monthly");
  const [ yearsList, setYearsList ] = useState([]);
  const [ selectedYear, setSelectedYear ] = useState(null);
  const [ startDate, setStartDate ] = useState(null);
  const [ endDate, setEndDate ] = useState(null);
  const [ csvData, setCsvData ] = useState(null);

  const isFirstLoad = useRef(true);
  const table = useTable();
  const csvLinkRef = useRef();

  console.log(startDate, 'startDate-------------------')

  const [ tableData, setTableData ] = useState([]);
  const [ filters, setFilters ] = useState({
    name: '',
    role: [],
    status: 'all',
  });
  const dataFiltered = applyFilter({
    inputData: tableData,
    comparator: getComparator(table.order, table.orderBy),
    filters,
  });
  const dataInPage = dataFiltered.slice(
    table.page * table.rowsPerPage,
    table.page * table.rowsPerPage + table.rowsPerPage
  );

  useEffect(() => {
    getProjects();
    getYearsList()
    getBalacneSheet(selectedProject);
  }, [ selectedTime, selectedYear, startDate, endDate ]);

  const getBalacneSheet = async (projectId) => {
    setLoading(true);
    const endpoint = projectId && projectId !== 'All'
      ? `${endpoints.accounting.balance_sheet.get_list}?${selectedProject ? `project_id=${projectId}` : ''}${selectedTime ? `&timeframe=${selectedTime}` : ''}${selectedYear !== 'All' && selectedTime === 'monthly' ? `&period=${selectedYear}` : ''}${selectedTime !== 'monthly' && startDate ? `&start_year=${startDate.getFullYear()}` : ''}${selectedTime !== 'monthly' && endDate ? `&end_year=${endDate.getFullYear()}` : ''}`
      : `${endpoints.accounting.balance_sheet.get_list}?timeframe=${selectedTime}${selectedYear !== 'All' && selectedTime === 'monthly' ? `&period=${selectedYear}` : ''}${selectedTime !== 'monthly' && startDate ? `&start_year=${startDate.getFullYear()}` : ''}${selectedTime !== 'monthly' && endDate ? `&end_year=${endDate.getFullYear()}` : ''}`;
    const data = await getRequest(endpoint);
    console.log('🚀 ~ getBalacneSheet ~ data:', data);
    setLoading(false);
    if (data) {
      setTableData(data);
    }
  };

  const getYearsList = async () => {
    const endpoint = `${endpoints.accounting.balance_sheet.get_list}?timeframe=yearly`
    const data = await getRequest(endpoint);
    const years = data.map((year) => {
      return year.period
    })
    setYearsList(years)
    if (isFirstLoad.current) {
      setSelectedYear(years.slice(-1)[ 0 ]);
      isFirstLoad.current = false;
    }
  }
  const getProjects = async () => {
    const data = await getRequest(endpoints.accounting.expenses.get_project_list);
    console.log('🚀 ~ getProjets ~ data:', data);
    if (data) {
      setprojectList(data);

    }
  };
  const handleChange = (event) => {
    const projectId = event.target.value
    setSelectedProject(projectId);
    getBalacneSheet(projectId)
    console.log('Selected Project ID:', event.target.value);
  };

  const handleTimeChange = (event) => {
    setSelectedTime(event.target.value);
  };

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
    // getBalacneSheet()
  };

  const handleSubmitFilters = async () => {
    const formData = new FormData();
    formData.append('project_id', selectedProject === 'All' ? '' : selectedProject);
    formData.append('timeframe', selectedTime)
    selectedTime === 'monthly' && formData.append('period', selectedYear)
    formData.append('start_year', startDate?.getFullYear() || '')
    formData.append('end_year', endDate?.getFullYear() || '')
    formData.append('tab_name', 'balance_sheet')
    const formDataObject = {}
    formData.forEach((value, key) => {
      formDataObject[ key ] = value
    })
    setLoading(true);
    const response = await postRequest(`${endpoints.accounting.finance_statement.post_list}/${rowId}/finance-statement-shows`, formData);
    setLoading(false);
    if (response?.metadata?.success) {
      enqueueSnackbar(JSON.stringify(response?.metadata?.message), { variant: 'success' })
      onSave()
    } else {
      enqueueSnackbar(JSON.stringify(response.message), { variant: 'error' })
    }
  }
  const handleExport = () => {
    if (csvLinkRef.current) {
      const csvFormattedData = [];
      csvFormattedData.push([ "" ]);
      const headers = [ "Account", ...tableData.map(({ period }) => String(period)) ];
      csvFormattedData.push(headers);
      const processSection = (entityType, label) => {
        csvFormattedData.push([ label, ...Array(tableData.length).fill("") ]);
        const totals = {};
        tableData.forEach((periodData, index) => {
          periodData.details[ entityType ].forEach((entity) => {
            if (!totals[ entity.account_name ]) {
              totals[ entity.account_name ] = Array(tableData.length).fill(0);
            }
            totals[ entity.account_name ][ index ] = entity.total_amount;
          });
        });
        Object.entries(totals).forEach(([ accountName, amounts ]) => {
          csvFormattedData.push([ String(accountName), ...amounts.map(amount => amount ? `$${amount.toLocaleString()}` : "0") ]);
        });
        csvFormattedData.push([
          `Total ${label}`,
          ...tableData.map((periodData) => `$${(periodData[ `total_${entityType === "assets" ? "asset" : entityType}` ] || 0).toLocaleString()}`)
        ]);
        csvFormattedData.push([]);
      };
      processSection("assets", "Assets");
      processSection("liabilities", "Liabilities");
      processSection("equity", "Equity");

      setCsvData(csvFormattedData);

      setTimeout(() => {
        csvLinkRef.current.link.click();
      }, 100);
    }
  };

  return (
    <>
      <Card sx={ { height: '100%', marginTop: '10px', overflow: 'hidden' } }>
        { ' ' }
        <CardContent>
          { loading ? (
            <Box height={ 700 }>
              <LoadingScreen />
            </Box>
          ) : (
            <>
              { page === 'dashboard' ? <Header name="View Balance Sheet" page={ page } /> : <Header name="Balance Sheet" /> }
              <Box
                sx={ {
                  display: 'flex',
                  paddingBottom: '20px',
                  justifyContent: 'space-between',
                  gap: '12px',
                } }
              >
                <Box
                  sx={ {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    padding: '5px 0',
                  } }
                >
                  <h5
                    style={ {
                      fontSize: '14px',
                      fontWeight: '400',
                      color: '#333',
                      margin: '0',
                      textTransform: 'none',
                    } }
                  >
                    Project Name
                  </h5>
                  <Select
                    sx={ { minWidth: 65, height: 35 } }
                    value={ selectedProject }
                    onChange={ handleChange }
                  >
                    <MenuItem value="All">All</MenuItem>
                    { projectList?.map((project) => (
                      <MenuItem key={ project.id } value={ project.id }>
                        { project.name }
                      </MenuItem>
                    )) }
                  </Select>

                  <Select
                    sx={ { minWidth: 65, height: 35 } }
                    value={ selectedTime }
                    onChange={ handleTimeChange }
                  >
                    <MenuItem value="monthly">Monthly</MenuItem>
                    <MenuItem value="quarterly">Quarterly</MenuItem>
                    <MenuItem value="yearly">Yearly</MenuItem>
                  </Select>
                  { selectedTime === 'monthly' && (
                    <Select
                      sx={ { minWidth: 65, height: 35 } }
                      value={ selectedYear }
                      onChange={ handleYearChange }
                    >
                      {/* <MenuItem value="All">All</MenuItem> */ }
                      { yearsList?.map((year) => {
                        return <MenuItem key={ year } value={ year }>{ year }</MenuItem>
                      }) }
                    </Select>
                  ) }

                  { selectedTime !== 'monthly' && (
                    <>
                      <DatePicker
                        name="start"
                        label="Start Year"
                        value={ startDate }
                        views={ [ 'year' ] }
                        openTo="year"
                        inputFormat="yyyy"
                        onChange={ date => setStartDate(date) }
                        renderInput={ (params) => (
                          <TextField
                            { ...params }
                            fullWidth
                          //error={!!error}
                          //helperText={error?.message}
                          />
                        ) }
                      />
                      <DatePicker
                        name="end"
                        label="End Year"
                        views={ [ 'year' ] } // Show only the year view
                        openTo="year" // Open directly to the year view
                        onChange={ date => setEndDate(date) }
                        inputFormat="yyyy"
                        //inputFormat="yyyy-MM-dd"
                        renderInput={ (params) => (
                          <TextField
                            { ...params }
                            fullWidth
                          //error={!!error}
                          //helperText={error?.message}
                          />
                        ) }
                      />

                    </>
                  ) }
                </Box>
                <Box
                  sx={ {
                    display: 'flex',
                    paddingBottom: '20px',
                    justifyContent: 'flex-end',
                    gap: '12px',
                  } }
                >

                  <Button
                    className="dark-button"
                    variant="contained"
                    startIcon={ <Iconify icon="ic:baseline-email" /> }
                  //onClick={handleOpenShareModal} 
                  >
                    Share By mail
                  </Button>
                  <Button
                    onClick={ () => {
                      handleExport();
                    } }
                    className="dark-button"
                    variant="contained"
                    startIcon={ <Iconify icon="solar:export-bold" /> }
                  >
                    Export
                  </Button>
                </Box>
              </Box>
              <Card
                sx={ {
                  boxShadow: '0px 0px 30px 0px #64748B1A',
                } }
              >
                <TableContainer sx={ { position: 'relative', overflow: 'auto' } }>
                  <BalanceSheetTable data={ tableData } tableType={ selectedTime } />
                </TableContainer>
              </Card>
            </>
          ) }
        </CardContent>
      </Card>
      {
        <CSVLink
          ref={ csvLinkRef }
          filename="Balance_Sheet_Report.csv"
          data={ csvData || [] } // Ensure it's always an array
          style={ { display: "none" } }
        />

      }
      <Box sx={ { display: 'flex', justifyContent: 'end', gap: 2, marginTop: 2 } }>
        { type ? (
          <LoadingButton
            onClick={ handleSubmitFilters }
            type="submit" variant="contained" className='dark-button'
          >
            Save
          </LoadingButton>
        ) :
          null
        }
      </Box>

    </>
  );
};
export default BalanceSheet;